export default "__VITE_PUBLIC_ASSET__fc903e80__"